import { render, staticRenderFns } from "./OtasukeForecastDetails.vue?vue&type=template&id=08ef9a79&"
import script from "./OtasukeForecastDetails.vue?vue&type=script&lang=js&"
export * from "./OtasukeForecastDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports